import { IInventoryPage } from '../../inventory-page.interface';


export const STORE_KEYWORD_PAGE: IInventoryPage = {
	'route': '/store/keyword',
	'title': 'Store Keyword',
	'uiReference': [
		'MOST POPULAR',
		'/mo',
		'Limited Free Version',
		'EVERYTHING'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/public-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-keyword/store-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-keyword/store-keyword.component.html'
	]
};
